<template>
  <f7-page>

    <f7-navbar
      title="Attestation de déplacement">
    </f7-navbar>

    <div class="main">
      <f7-list
        no-hairlines-md>
        <f7-list-input
          label="Nom"
          type="text"
          placeholder="ex : Vincent Dupont"
          :value="form.name"
          @input="name" />
        <f7-list-input
          label="Date de naissance"
          type="datepicker"
          placeholder="Votre date de naissance"
          readonly
          ref="calendar"
          @change="birthdate" />
        <f7-list-input
          label="Adresse"
          type="textarea"
          placeholder="Votre adresse"
          :value="form.address"
          @input="address"
          @blur="getcity" />
        <li>
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">Signature</div>
              <div
                ref="pad"
                class="item-input-wrap">
                <canvas
                  ref="signature"
                  class="signature"
                  :width="width"
                  :height="height" />
              </div>
              <f7-button
                small
                style="padding-left:0"
                @click="clearPad">
                Refaire ma signature
              </f7-button>
            </div>
          </div>
        </li>
      </f7-list>

      <f7-list
        inline-labels
        no-hairlines-md>
        <f7-list-item
          title="Motif de sortie"
          smart-select
          :smart-select-params="{ openIn: 'sheet', sheetCloseLinkText: 'Valider' }">
          <select
            multiple
            name="reason"
            @change="reasons">
            <option
              v-for="(r, i) in options"
              :key="i"
              :value="r.title"
              :selected="selected(r.title)">
              {{ r.title }}
            </option>
          </select>
        </f7-list-item>
        <f7-list-input
          label="Fait à"
          type="text"
          placeholder="Votre ville"
          :value="form.city"
          @input="city" />
      </f7-list>

      <f7-block>
        <f7-button
          large
          fill
          @click="generate">
          Générer l'attestion pour aujoud'hui
        </f7-button>
      </f7-block>
    </div>

  </f7-page>
</template>

<script>
import * as jsPDF from 'jspdf'
import moment from 'moment'
import axios from 'axios'
import SignaturePad from 'signature_pad'
import reasons from '@/data/reasons'
export default {
  name: 'Form',
  data () {
    return {
      form: {
        name: '',
        birthdate: null,
        address: '',
        reasons: [],
        city: '',
        signature: null
      },
      loading: false,
      width: 0,
      height: 150,
      signaturePad: null,
      options: reasons
    }
  },
  watch: {
    form: {
      deep: true,
      handler () {
        this.save()
      }
    }
  },
  methods: {
    initSignaturePad () {
      this.width = this.$refs.pad.offsetWidth
      const canvas = this.$refs.signature
      this.signaturePad = new SignaturePad(canvas)
      if (this.form.signature) {
        this.signaturePad.fromDataURL(this.form.signature, { width: this.width, height: this.height })
      }
    },
    name (e) {
      this.form.name = e.target.value
    },
    birthdate (e) {
      this.form.birthdate = e.target.value
    },
    address (e) {
      this.form.address = e.target.value
    },
    getcity (e) {
      if (!this.form.city) {
        this.loading = true
        const q = e.target.value.split(' ').join('+')
        axios.get('https://api-adresse.data.gouv.fr/search/?q=' + q + '&autocomplete=0')
          .then(res => {
            if (res.data.features[0]) {
              this.form.city = res.data.features[0].properties.city
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    city (e) {
      this.form.city = e.target.value
    },
    reasons (e) {
      const reasons = []
      const selected = e.target.selectedOptions
      for (const o of selected) {
        reasons.push(o.value)
      }
      this.form.reasons = reasons
      this.save()
    },
    clearPad () {
      if (this.signaturePad) this.signaturePad.clear()
    },
    save () {
      localStorage.setItem('form', JSON.stringify(this.form))
    },
    selected (label) {
      return this.form.reasons ? this.form.reasons.includes(label) : false
    },
    generate () {
      this.form.signature = this.signaturePad.toDataURL('image/png')
      // eslint-disable-next-line
      const doc = new jsPDF()

      // title
      doc.setFontSize(15)
      doc.setFontStyle('bold')
      doc.text('ATTESTATION DE DÉPLACEMENT DÉROGATOIRE', 105, 30, { align: 'center' })
      doc.setFontSize(11)
      doc.setFontStyle('normal')
      doc.text('En application de l’article 1er du décret du 16 mars 2020 portant réglementation des déplacements dans le cadre de la lutte contre la propagation du virus Covid-19 :', 105, 40, { align: 'center', maxWidth: '150' })

      // me
      doc.setFontSize(12)
      doc.text([
        'Je soussigné(e)',
        'Mme / M. ' + this.form.name,
        'Né(e) le : ' + this.form.birthdate,
        'Demeurant : ' + this.form.address
      ], 20, 70, { align: 'left' })

      // body
      doc.text('certifie que mon déplacement est lié au motif suivant autorisé par l’article 1er du décret du 16 mars 2020 portant réglementation des déplacements dans le cadre de la lutte contre la propagation du virus Covid-19 :', 20, 100, { align: 'justify', maxWidth: '170' })

      // reasons
      const reasons = this.form.reasons.map(r => {
        return '\n\n' + this.options.find(o => o.title === r).description
      })
      doc.text(reasons, 30, 120, { align: 'left', maxWidth: '140' })

      // footer
      const footer = ['Fait à ' + this.form.city + ',', '\nle ' + moment().format('L')]
      doc.text(footer, 130, 220, { align: 'left', maxWidth: '60' })

      doc.addImage(this.form.signature, 'PNG', 130, 230, this.width / 6, this.height / 6)
      doc.save('attestation_de_deplacement_derogatoire.pdf')
    }
  },
  mounted () {
    this.initSignaturePad()
    if (this.form.birthdate) {
      const d = this.form.birthdate.split('/').reverse().join('-')
      this.$refs.calendar.f7Calendar.setValue([new Date(d)])
    }
  },
  created () {
    const savedData = localStorage.getItem('form')
    if (savedData) {
      this.form = JSON.parse(savedData)
    }
  }
}
</script>

<style lang="scss">
.main {
  @media only screen and (min-device-width: 768px){
    max-width: 440px;
    margin: auto;
    padding: 1px 20px;
    background: white;
  }
}
.signature {
  background: white;
}
</style>
